import script from "./reset-check-list-confirmation-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./reset-check-list-confirmation-modal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__